import { render, staticRenderFns } from "./robots-manager.vue?vue&type=template&id=19c8dab0&scoped=true&"
import script from "./robots-manager.vue?vue&type=script&lang=js&"
export * from "./robots-manager.vue?vue&type=script&lang=js&"
import style0 from "./robots-manager.vue?vue&type=style&index=0&id=19c8dab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8dab0",
  null
  
)

export default component.exports